module.exports = __webpack_public_path__ + "static/img/TD.6f3d9181.svg";